var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 920",
    clipPath: "url(#clip0_1626_22550)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus / 24 / Outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.7985 10.2126L7.55582 5.96996L11.7985 1.72732C11.986 1.53978 12.0913 1.28543 12.0913 1.02021C12.0913 0.754995 11.986 0.500641 11.7985 0.313105C11.6109 0.125569 11.3566 0.0202118 11.0913 0.0202119C10.8261 0.0202117 10.5718 0.125569 10.3842 0.313105L6.1416 4.55575L1.89896 0.313105C1.71142 0.125569 1.45707 0.0202117 1.19185 0.0202119C0.926637 0.0202118 0.672283 0.125569 0.484747 0.313105C0.29721 0.500641 0.191854 0.754995 0.191854 1.02021C0.191854 1.28543 0.29721 1.53978 0.484747 1.72732L4.72739 5.96996L0.484747 10.2126C0.29721 10.4001 0.191853 10.6545 0.191853 10.9197C0.191853 11.1849 0.29721 11.4393 0.484747 11.6268C0.672283 11.8144 0.926637 11.9197 1.19185 11.9197C1.45707 11.9197 1.71142 11.8144 1.89896 11.6268L6.1416 7.38417L10.3842 11.6268C10.5718 11.8144 10.8261 11.9197 11.0914 11.9197C11.3566 11.9197 11.6109 11.8144 11.7985 11.6268C11.986 11.4393 12.0914 11.1849 12.0914 10.9197C12.0914 10.6545 11.986 10.4001 11.7985 10.2126Z",
    fill: "#25262D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1626_22550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.f10f83338cbfe6829a2f88fb883df059.svg";
export { ForwardRef as ReactComponent };